/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label } from 'reactstrap';
import { connect } from 'react-redux'

class DeletePollerModal extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            ...props
        }

        this.attemptDelete = this.attemptDelete.bind(this) 
    }

    attemptDelete() 
    {
        if(this.props.type == 'mailbox')
        {
            //Set document to status deleted in archive
            fetch(window.location.protocol + '//' + window.location.host + '/api/poller/inbox?id='+this.props.destination,{
                method: 'DELETE'
            })
            .then(result => 
            {
                this.props.refresh()
                this.props.toggle()
            })
            .catch(error=>
            {
                //need to log the error
                this.props.alert.error('An error occurred whilst attemping mailbox poller deletion ' + error);
                
            });
        }
        else if(this.props.type == 'directory')
        {
            //Set document to status deleted in archive
            fetch(window.location.protocol + '//' + window.location.host + '/api/poller/directory?id='+this.props.destination,{
                method: 'DELETE'
            })
            .then(result => 
            {
                this.props.refresh()
                this.props.toggle()
            })
            .catch(error=>
            {
                //need to log the error
                this.props.alert.error('An error occurred whilst attemping mailbox poller deletion ' + error);
                
            });
        }
    }

    render() {

        const { localisation } = this.props.userReducer;

        return (
            <div>
               <Modal isOpen={this.props.modal} toggle={this.props.toggle} className='modal-dialog'>
                    <ModalHeader toggle={this.props.toggle}>{localisation['delete_pollers_header'] ? localisation['delete_pollers_header'].element_lang : 'Delete Pollers'}</ModalHeader>
                    <ModalBody>
                        <Label size={10}>
                            Are you sure you wish the remove the selected pollers?
                        </Label>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={this.attemptDelete}>Delete</Button>
                        <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default connect(state => state)(DeletePollerModal);